<template>
    <el-dialog
     class="promptChangedDialog"
     :visible.sync="promptShow"
     width="430px"
     :close-on-click-modal="false"
     :show-close="false">
        <span class="promptTip">即将离开当前程序，是否保存？</span>
        <div slot="footer" class="dialog-footer">
            <el-button @click="$emit('cancel')">取 消</el-button>
            <div>
                <el-button @click="$emit('unSaveWork')" type="primary">不保存</el-button>
                <el-button @click="$emit('saveWork')" type="primary">保存</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: {
        promptShow: {
            type: Boolean,
            default: false
        },
        saveWork: {
            type: Function
        },
        unSaveWork: {
            type: Function
        },
        cancel: {
            type: Function
        },
    },
}
</script>
<style lang="scss">
.promptChangedDialog {
    .el-dialog__body .promptTip {
        display: inline-block;
        width: 100%;
        color: #333;
        font-size: 25px;
        text-align: center;
    }
    .dialog-footer {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: flex-end;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/classroom1/components/promptChangedDialog.vue